export class ServerErrorMessage {
    source: string;
    url: string;
    message: string;
    optional1?: string;
    optional2?: string;
}
